export default "__VITE_ASSET__58b9774f__"